import React from 'react';
import { Mail, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
      { name: 'Virtual Assistant Services', href: '#services' },
      { name: 'Bookkeeping', href: '#services' },
      { name: 'Accounting Services', href: '#services' },
      { name: 'Data Entry', href: '#services' },
      { name: 'Back Office Support', href: '#services' },
      { name: 'Document Production', href: '#services' },
      { name: 'Portal Management', href: '#services' },
      { name: 'Calling Support', href: '#services' },
      { name: 'General Administrative Support', href: '#services' },
      { name: 'Records Management', href: '#services' }
    ],
    Company: [
      { name: 'About Us', href: '#about' },
      { name: 'How It Works', href: '#how-it-works' },
      { name: 'Pricing', href: '#pricing' },
      { name: 'Contact', href: '#contact' }
    ],
    Legal: [
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' },
      { name: 'Cookie Policy', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: Linkedin, href: 'https://www.linkedin.com/company/flexdesk-uk-limited/', label: 'LinkedIn' },
    { icon: Instagram, href: 'https://www.instagram.com/flexdesk_uk/', label: 'Instagram' },
    { icon: Facebook, href: 'https://www.facebook.com/share/1Cq1v7FjSZ/', label: 'Facebook' }
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        {/* Top Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src="/flexdesk-logo-white.png" alt="Flexdesk UK logo" className="h-11 w-auto object-contain" />
            </div>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Your trusted administrative partner. Empowering businesses across the UK with comprehensive administrative services.
            </p>
            <div className="space-y-3">
              <a href="mailto:info@flexdeskuk.co.uk" className="flex items-center gap-3 text-slate-400 hover:text-yellow-400 transition-colors">
                <Mail className="w-4 h-4" />
                <span>info@flexdeskuk.co.uk</span>
              </a>
              <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>61 Bridge Street, Kington, HR5 3DJ, United Kingdom</span>
              </div>
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-white font-semibold mb-4">{title}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-slate-400 hover:text-blue-400 transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-slate-800 my-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-slate-500 text-sm">
            © {currentYear} Flexdesk UK. All rights reserved.
          </p>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="p-2 bg-slate-800 hover:bg-yellow-500 rounded-lg transition-all duration-300 group"
                >
                  <Icon className="w-5 h-5 text-slate-400 group-hover:text-slate-900 transition-colors" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
